import { render, staticRenderFns } from "./Shapes.vue?vue&type=template&id=544111bb&scoped=true"
import script from "./Shapes.vue?vue&type=script&lang=js"
export * from "./Shapes.vue?vue&type=script&lang=js"
import style0 from "./Shapes.vue?vue&type=style&index=0&id=544111bb&prod&scoped=true&lang=css"
import style1 from "./Shapes.vue?vue&type=style&index=1&id=544111bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544111bb",
  null
  
)

export default component.exports